if (!customElements.get("product-card")) {
  customElements.define(
    "product-card",
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        document.addEventListener(
          "class:switched",
          this.onClassSwitched.bind(this),
        );
        if (this.dataset.nosto == "true") {
          this.addEventListener(
            "cart:add",
            this.nostoRecommendationATC.bind(this),
          );
          this.querySelector("a").addEventListener(
            "click",
            this.nostoRecommendationPageTransition.bind(this),
          );
        }
      }
      nostoRecommendationATC(e) {
        const { cart: addedItem } = e.detail;
        const correspondingNostoComponent = this.closest(
          "nosto-recommendations",
        );
        nostojs((api) => {
          api.recommendedProductAddedToCart(
            addedItem.product_id,
            correspondingNostoComponent.dataset.placement,
          );
        });
      }

      nostoRecommendationPageTransition(e) {
        const noRedirectHappened =
          e.target.getAttribute("data-disableanchornosto") == "true" ||
          e.target.closest("[data-disableanchornosto]");
        if (noRedirectHappened) return;

        const payload = {
          product_id: this.dataset.product,
        };
        nostojs((api) => {
          api
            .createRecommendationRequest()
            .setProducts(
              [payload],
              this.closest("nosto-recommendations").dataset.placement,
            )
            .load();
        });
      }
      connectedCallback() {
        this.addEventListener("mouseenter", this.fetchImages.bind(this), {
          once: true,
        });
      }
      onClassSwitched(e) {
        this.addEventListener("mouseenter", this.fetchImages.bind(this));
      }
      fetchImages() {
        this.images = this.querySelectorAll("snap-slider img");
        this.images.forEach((image) => {
          if (image.complete) return;
          const img = new Image();
          img.src = image.src;
          img.srcset = image.srcset;
        });
      }
    },
  );
}

if (!customElements.get("variant-selector")) {
  customElements.define(
    "variant-selector",
    class VariantSelector extends HTMLElement {
      constructor() {
        super();
        this.wrapper = this.querySelector("._variantsWrapper");
        this.classToAdd = ["!-translate-y-full"];
        this.selectASizeWrapper = this.querySelector("._selectASize");
        this.plusButton = this.querySelector("._plus");
        this.parentProduct = this.closest("[data-product][data-section]");
        this.form = this.querySelector("form");
        this.inputs = this.querySelectorAll("input");
      }

      connectedCallback() {
        // observe parent product and init when in view
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.init();
            observer.disconnect();
          }
        });
        observer.observe(this);
      }

      init() {
        this.selectASizeWrapper?.addEventListener(
          "click",
          this.onSelectASizeClick.bind(this),
        );
        this.plusButton?.addEventListener("click", this.onPlusClick.bind(this));
        this.addEventListener("cart:add", this.onCartAddEvent.bind(this));
        this.parentProduct.addEventListener(
          "mouseleave",
          this.resetPosition.bind(this),
        );
        this.inputs.forEach((input) => {
          input.onchange = "";
          input.addEventListener("change", this.onInputChange.bind(this));
        });
      }

      onPlusClick(e) {
        e.preventDefault();
        this.plusButton.style.transform = "translateY(200%)";
        this.classToAdd.forEach((className) => {
          this.wrapper.classList.toggle(className);
        });
      }

      onInputChange(e) {
        const label = e.target.labels[0];

        const loadingSpinnerTemplate =
          document.querySelector("#loading-spinner");
        const loadingSpinner = loadingSpinnerTemplate.content.cloneNode(true);
        label.appendChild(loadingSpinner);
        label.disabled = true;

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        };

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            let event = new CustomEvent("cart:add", {
              bubbles: true,
              detail: {
                cart: response,
                img: this.parentProduct.querySelector("img._mainImage").src,
              },
            });

            document.dispatchEvent(event);
            this.dispatchEvent(event);

            function handleResponse() {
              let res = { sections: JSON.parse(this.responseText) };
              document.querySelector("cart-drawer-items").updateSections(res);
            }

            let sections = document
              .querySelector("cart-drawer-items")
              .getSectionsToRender()
              .map((section) => section.section);

            sections = sections.join(",");

            const request = new XMLHttpRequest();
            request.addEventListener("load", handleResponse);
            request.open("GET", `/?sections=${sections}`, true);
            request.send();

            label.classList.add("!bg-primary", "text-white");
            label.querySelector(".loadingSpinner").remove();
            setTimeout(() => {
              label.classList.remove("!bg-primary", "text-white");
              label.disabled = false;
            }, 2000);
            this.form.querySelector('input[data-false="true"]').checked = true;
          })
          .catch((e) => {
            console.log(e);
          });
      }

      onSelectASizeClick(e) {
        e.preventDefault();
        this.classToAdd.forEach((className) => {
          this.wrapper.classList.toggle(className);
        });
        this.plusButton.style.transform = "";
      }

      onCartAddEvent(e) {
        const textNode = this.selectASizeWrapper.querySelector("span");
        const oldText = textNode.textContent;
        textNode.textContent = "Added to cart!";
        setTimeout(() => {
          textNode.textContent = oldText;
        }, 2000);
      }

      resetPosition() {
        this.classToAdd.forEach((className) => {
          this.wrapper.classList.remove(className);
        });
        this.plusButton.style.transform = "";
      }
    },
  );
}

if (!customElements.get("change-swatch")) {
  customElements.define(
    "change-swatch",
    class ChangeSwatch extends HTMLElement {
      constructor() {
        super();
        this.parentProduct = this.closest("[data-product][data-section]");
        this.showHiddenSwatchesButton = this.parentProduct.querySelector(
          "._showHiddenSwatches",
        );
      }
      connectedCallback() {
        // observe parent product and init when in view
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.init();
            observer.disconnect();
          }
        });
        observer.observe(this.parentProduct);
      }

      init() {
        this.querySelector("label").addEventListener(
          "click",
          this.changeSwatch.bind(this),
        );
        this.showHiddenSwatchesButton?.addEventListener(
          "click",
          this.onShowHiddenSwatchesClick.bind(this),
        );
        this.parentNode.addEventListener(
          "mouseenter",
          this.prefetchImages.bind(this),
          { once: true },
        );
      }

      async prefetchImages() {
        if (this.prefetched) return;

        await fetch(
          `${window.routes.root_url}products/${this.dataset.handle}?section_id=api-product-swatch-json`,
        )
          .then((response) => {
            return response.text();
          })
          .then((response) => {
            const html = new DOMParser().parseFromString(response, "text/html");
            const stringified =
              html.querySelector(".shopify-section").innerHTML;
            this.swatch = JSON.parse(stringified);
          });

        const grid = document.querySelector('[data-target="product-grid"]');
        let image;
        if (grid && grid.dataset.activeIndex == 2) {
          image = this.swatch.images[this.swatch.images.length - 1];
        } else {
          image = this.swatch.images[0];
        }

        const img = new Image();
        img.src = image;
        this.prefetched = true;
      }
      onShowHiddenSwatchesClick(e) {
        e.preventDefault();
        this.showHiddenSwatchesButton.classList.add("hidden");
        this.parentProduct
          .querySelectorAll("change-swatch.hidden")
          .forEach((swatch) => {
            swatch.classList.remove("hidden");
          });
      }
      async changeSwatch() {
        let prodId = this.dataset.id;
        let variantId = this.dataset.vid;

        if (this.dataset.discount && this.closest("product-card").querySelector(".sale-badge")) {
          this.closest("product-card").querySelector(".sale-badge").innerText =
            `SAVE ${this.dataset.discount}%`;
        }
        if (this.dataset.price) {
          this.closest("product-card").querySelector(".base-price").innerText =
            this.dataset.price;
        }
        
        this.closest("product-card")
          .querySelector(".status_button")
          .setAttribute("product-id", prodId);
        this.closest("product-card")
          .querySelector(".status_button")
          .setAttribute("variant-id", variantId);
        const loadingSpinnerTemplate =
          document.querySelector("#loading-spinner");
        const loadingSpinner = loadingSpinnerTemplate.content.cloneNode(true);
        this.appendChild(loadingSpinner);

        if (!this.prefetched) await this.prefetchImages();
        this.dataset.handle = this.swatch.handle;
        const mainImages =
          this.parentProduct.querySelectorAll("img._mainImage");
        const ghostImages =
          this.parentProduct.querySelectorAll("img._ghostImage");
        const otherImages =
          this.parentProduct.querySelectorAll("img._otherImage");
        mainImages.forEach((image) => {
          image.src = this.swatch.images[0];
          image.srcset = this.swatch.images[0];
        });

        otherImages.forEach((image, index) => {
          // index + 1 because main image is skipped
          image.src = this.swatch.images[index + 1];
          image.srcset = this.swatch.images[index + 1];
        });

        ghostImages.forEach((image) => {
          image.src = this.swatch.images[this.swatch.images.length - 1];
          image.srcset = this.swatch.images[this.swatch.images.length - 1];
        });

        this.urls = this.parentProduct.querySelectorAll("a");
        this.urls.forEach((url) => {
          const urlArray = url.href.split("/");
          urlArray[urlArray.length - 1] = this.swatch.handle;
          url.href = urlArray.join("/");
        });

        // change variant ids and availability
        this.inputs = this.parentProduct.querySelectorAll("input[name='id']");

        this.inputs.forEach((input) => {
          this.swatch.variants.forEach((variant) => {
            if (variant.title == input.dataset.title) {
              input.value = variant.id.split("&")[0].split("\\")[0];
              input.disabled = !variant.available;

              const label = input.labels[0];
              label.dataset.variantId = variant.id;
              label.dataset.available = variant.available;
            }
          });
        });

        this.removeChild(this.querySelector(".loadingSpinner"));
      }
    },
  );
}
